import { render, staticRenderFns } from "./questionAdd.vue?vue&type=template&id=d23e1950&scoped=true&"
import script from "./questionAdd.vue?vue&type=script&lang=ts&"
export * from "./questionAdd.vue?vue&type=script&lang=ts&"
import style0 from "./questionAdd.vue?vue&type=style&index=0&id=d23e1950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23e1950",
  null
  
)

export default component.exports